import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, withRouter } from 'react-router-dom';
import axios from 'axios';

import './index.css';

class HeadComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      category: [],
    };
  }

  handleGetCategory = () => {
    axios({
      method: 'get',
      url: 'https://eclipsesp-app.herokuapp.com/category',
      // responseType: 'stream'
    })
      .then((res) => {
        this.setState({
          category: res.data.data,
        });
      })
      .catch((err) => console.log(err));
  };

  componentDidMount() {
    this.handleGetCategory();
  }

  render() {
    return (
      <div className="container-bg-head">
        <Container>
          <Row>
            <Col md={{ span: 7 }}>
              <div className="d-flex flex-column ml-5 py-5">
                <span className="title-head"> Eclipse Software Project. </span>
                <span> A Website To Show Off Your Project </span>
              </div>
            </Col>
            <Col md={{ span: 5 }}>
              <div className="d-flex justify-content-end mr-5 py-5">
                <span className="mr-3"> Filter: </span>
                <div className="d-flex flex-column">
                  <span>
                    Category
                    <hr className="hr-option" />
                  </span>

                  {this.state.category.map((cat, idx) => {
                    return (
                      <Link
                        key={idx}
                        className="mb-3 filter-name"
                        to={`/project-category/${cat.category_slug}`}
                      >
                        {cat.name}
                      </Link>
                    );
                  })}
                  <Link className="mb-3 filter-name" to={`/project`}>
                    Clear Filter
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withRouter(HeadComponent);
